// extracted by mini-css-extract-plugin
export default {"errorPage":"style_errorPage__lGkGu","errorImg":"style_errorImg__ReXXe","errorTitle":"style_errorTitle__4W-xL","button":"style_button__m25Cm"};